const rentOwnOptions = [
  {"text":"Please Select","value":""},
  {"text":"Mortgage","value":"Mortgage"},
  {"text":"Rent","value":"Rent"},
  {"text":"Family","value":"Family"},
  {"text":"Other","value":"Other"},
  {"text":"Own outright","value":"OwnOutright"},
  {"text":"Military Program","value":"Military"}
];
export default rentOwnOptions;
